import { api } from "./api"

export const DOWNLOAD_REPORT = async (type, params) => {
    const {data} = await api.post("/reports/download/pdf", {type, params})
    return data;
}

export const GET_REPORTS = async () => {
    const {data} = await api.get("/reports/all")
    return data;
}

export const GET_REPORT_DETAILS = async (id: string) => {
    const {data} = await api.get(`/reports/${id}/details`)
    return data;
}
